import layout from './layout.json';
import landing from './landing.json';
export default {
    landing,
    layout,
};
